<script setup lang="ts">
import { computed } from "vue";
import type { Team } from "@shared/types";
import { teamStatus } from "@shared/status";

const props = defineProps<{ team: Team; size?: "xs" | "sm" }>();
const status = computed(() => teamStatus(props.team));
</script>

<template>
  <span
    v-if="status"
    :class="[
      'inline-block rounded font-bold uppercase tracking-wide leading-none ring-1 align-middle',
      props.size === 'xs' ? 'px-1 py-0.5 text-[9px]' : 'px-1.5 py-0.5 text-[10px]',
      status.kind === 'through'
        ? 'bg-emerald-100 text-emerald-700 ring-emerald-300'
        : 'bg-slate-200 text-slate-500 ring-slate-300',
    ]"
  >{{ status.label }}</span>
</template>
